import type { ComponentProps } from "react";
import { DayPicker, Dropdown, type DropdownProps } from "react-day-picker";
import "react-day-picker/style.css";

import { cn } from "@/lib/utils";

export type CalendarProps = ComponentProps<typeof DayPicker>;

function YearsDropdown(props: DropdownProps) {
  return <Dropdown {...props} data-testid="date-field-year" />;
}

function MonthsDropdown(props: DropdownProps) {
  return <Dropdown {...props} data-testid="date-field-month" />;
}

/**
 * shadcn-style DayPicker wrapper. DateField always passes `captionLayout="dropdown"`
 * so month and year are native `<select>`s (no year spinning).
 */
export function Calendar({
  className,
  classNames,
  captionLayout = "dropdown",
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      captionLayout={captionLayout}
      navLayout="around"
      weekStartsOn={1}
      className={cn(
        "[--rdp-accent-color:var(--primary)] [--rdp-accent-background-color:var(--accent)] [--rdp-today-color:var(--primary)] [--rdp-day-height:2.25rem] [--rdp-day-width:2.25rem] [--rdp-day_button-height:2.25rem] [--rdp-day_button-width:2.25rem] [--rdp-nav_button-height:2.25rem] [--rdp-nav_button-width:2.25rem] [--rdp-nav-height:2.5rem] text-sm",
        className,
      )}
      classNames={classNames}
      {...props}
      fixedWeeks={props.fixedWeeks ?? true}
      components={{
        YearsDropdown,
        MonthsDropdown,
        ...props.components,
      }}
    />
  );
}
